{
  "forms.title": "Formularios",
  "forms.empty": "No hay formularios configurados."
}
